export default class Accordion {
	private triggerClass: string;
	private trayClass: string;
	private openClass: string;

	constructor(triggerClass: string, trayClass: string) {
		this.triggerClass = triggerClass;
		this.trayClass = trayClass;
		this.openClass = this.triggerClass + '--open';
		this.buildAccordions();
	}

	public buildAccordions(): void {
		const triggers: HTMLCollection = document.getElementsByClassName(this.triggerClass);
		for (let index: number = 0; index < triggers.length; index++) {
			const element: Element = triggers[index];
			element.addEventListener('click', this.toggleAccordionCB);
		}
	}

	public toggleAccordion(event: Event): void {
		const target: HTMLElement = event.currentTarget as HTMLElement;
		if (target.classList.contains(this.openClass)) {
			this.closeAccordion(target);
		} else {
			this.openAccordion(target);
		}
	}
	public toggleAccordionCB = (event: Event): void => {
		this.toggleAccordion(event);
	}

	public openAccordion(el: HTMLElement): void {
		el.classList.add(this.openClass);
	}

	public closeAccordion(el: HTMLElement): void {
		el.classList.remove(this.openClass);
	}
}
